import { render, staticRenderFns } from "./deliveryPreview.vue?vue&type=template&id=22cc50d2&scoped=true&"
import script from "./deliveryPreview.vue?vue&type=script&lang=js&"
export * from "./deliveryPreview.vue?vue&type=script&lang=js&"
import style0 from "./deliveryPreview.vue?vue&type=style&index=0&id=22cc50d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22cc50d2",
  null
  
)

export default component.exports